module.exports = __webpack_public_path__ + "img/YoutubeIconWelcomePopup.fc45222b.png";